import React, { useState } from 'react';
//
import { Button } from '../../../components/buttons/buttons';
import { Modal } from '../../../components/modals/antd-modals';
import { BasicFormWrapper } from '../../styled';

const ConfirmModal = ({ visible, onCancel, handleSubmit, title, content }) => {
  const [loading, setLoading] = useState(false);
  const handleSubmitClick = async () => {
    setLoading(true);
    await handleSubmit();
    onCancel();
    setLoading(false);
  };

  return (
    <Modal
      type="primary"
      title={title}
      visible={visible}
      footer={[
        <div key="1" className="car-modal-footer">
          <Button
            size="default"
            style={{ backgroundColor: '#155BDC', color: '#fff' }}
            key="submit"
            onClick={handleSubmitClick}
            disabled={loading}
          >
            Initiate
          </Button>
          <Button size="default" type="white" key="back" outlined onClick={onCancel} disabled={loading}>
            Cancel
          </Button>
        </div>,
      ]}
      onCancel={onCancel}
    >
      <div className="car-modal">
        <BasicFormWrapper>{content}</BasicFormWrapper>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
